import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { t } from "../lib/i18n";
import { toast } from "sonner";
import { Lightning } from "@phosphor-icons/react";

export default function Register() {
  const { user, register, error } = useAuth();
  const [form, setForm] = useState({ email: "", password: "", handle: "", country: "PL" });
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (user && user !== false) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/me"} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const data = await register(form);
    setBusy(false);
    if (data) {
      toast.success(t.registerSuccess);
      nav("/me", { replace: true });
      setTimeout(() => {
        if (window.location.pathname === "/register") window.location.href = "/me";
      }, 200);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Lightning size={32} weight="fill" className="text-[#FF0055] mx-auto" />
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FF0055] font-mono mt-3">
            // {t.navRegister}
          </div>
          <h1 className="font-display font-black uppercase italic text-5xl mt-2">
            {t.registerTitle}
          </h1>
          <p className="text-white/50 text-sm mt-2">{t.registerSub}</p>
        </div>

        <form onSubmit={submit} className="border border-white/10 bg-[#0C0C14] p-6 space-y-4" data-testid="register-form">
          <Input label={t.yourHandle} value={form.handle}
            onChange={(v) => setForm({ ...form, handle: v })} testid="register-handle" />
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2">
              <Input label={t.email} type="email" value={form.email}
                onChange={(v) => setForm({ ...form, email: v })} testid="register-email" />
            </div>
            <Input label={t.country} value={form.country}
              onChange={(v) => setForm({ ...form, country: v.toUpperCase() })} testid="register-country" />
          </div>
          <Input label={`${t.password} (${t.passwordMin})`} type="password" value={form.password}
            onChange={(v) => setForm({ ...form, password: v })} testid="register-password" />
          {error && (
            <div data-testid="register-error" className="text-xs text-[#FF0055] font-mono">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit"
            className="w-full px-6 py-3 bg-[#FF0055] hover:bg-[#FF3377] text-white font-bold uppercase tracking-[0.25em] text-sm transition-colors disabled:opacity-50"
          >
            {busy ? t.creating : t.registerCta}
          </button>
          <div className="text-xs text-white/50 text-center pt-2">
            {t.haveAccount}{" "}
            <Link to="/login" className="text-[#00E5FF] hover:underline" data-testid="to-login-link">
              {t.toLogin}
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

function Input({ label, type = "text", value, onChange, testid }) {
  return (
    <div>
      <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40 block mb-2">
        {label}
      </label>
      <input
        data-testid={testid}
        type={type}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm focus:outline-none focus:border-[#00E5FF]"
      />
    </div>
  );
}
